<template class="border-white">
  <input
    @change="$emit('update:modelValue', updatedShowCheck)"
    type="checkbox"
    :id="fieldId"
    class="mr-2 hidden"
    v-bind="$attrs"
  />
  <label
    :for="fieldId"
    class="items-center cursor-pointer select-none text-lg bg-blue border-2 border-l-0 border-white"
    :class="[`text-white hover:font-bold`, checked ? 'font-bold' : '']"
    style="display: flex; flex-flow: column; height:140px; width:40px; text-align: center; border-top-right-radius: 20px;border-bottom-right-radius: 20px; position: absolute;top: 42px; left: 0;"
  >
    <div
      v-show="!showCheck"
      class="mr-2 bg-white "
      :class="[`rounded-sm border border-${color}`]"
      style="width: 18px; height: 18px; padding: 2px 2px;  margin: 0 auto; margin-top: 10px;"
    >
      <div
        style="width: 12px; height: 12px;"
        :class="[`rounded-sm bg-${color}`]"
      ></div>
    </div>
    <div
      v-show="showCheck"
      class="mr-2 bg-white"
      :class="[`rounded-sm border border-${color}`]"
      style="width: 18px; height: 18px;  margin: 0 auto; margin-top: 10px;"
    ></div>
    <span class="mt-1" style="writing-mode: vertical-rl;">
      {{ value }}
    </span>
  </label>
</template>
<script>
import { ref } from '@vue/reactivity'
export default {
  name: 'AppImgPrvCheckbox',
  emits: ['update:showCheck'],
  props: {
    value: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },

    color: {
      type: String,
      default: '',
    },

    showCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const updatedShowCheck = ref(props.showCheck)
    return {
      updatedShowCheck,
    }
  },
}
</script>
